import { Footer2022, Intro2022 } from '../components';
import { use2022Page } from '../shared';

const panelJudges = [
  ['EmilChan', '陳家豪教授', '雲端與流動運算專業人士協會<br>主席'],
  ['IrEricChan', '陳思源工程師', '數碼港<br>首席公眾使命官'],
  ['DrLawrenceCheung', '張梓昌博士', '生產力局<br>首席創新總監'],
  ['DanielChun', '秦仲宇先生', '智慧城市聯盟副會長暨研究及藍圖委員會<br>主席'],
  ['RickyChoi', '蔡偉傑先生', '數碼港<br>智慧生活組高級經理'],
  ['francisfong', '方保僑先生', '香港互動市務商會<br>創會及榮譽會長'],
  ['SamHui', '許健生先生', '香港電腦商會<br>主席'],
  ['peterkoo', '顧向聖先生', '大灣區5G產業聯盟<br>金融行業委員會總監'],
  ['sandraleung', '梁淑寶小姐', '香港科技創新促進組<br>創辦人兼執行總監'],
  ['vincentso', '蘇增慰先生', '香港零售科技商會<br>會長'],
  ['yvonnewong', '黃麗芳小姐', '香港青聯科技協會<br>主席'],
] as const;

const Judges2022Zh = () => {
  use2022Page({ cate: 'judges', lang: 'zh', title: '2022智慧生活夥伴大獎 - 評審' });
  return (
    <div className="slpa2022-root">
      <Intro2022 lang="zh" />
      <section id="LeadIn"><div className="wave_bg"><img src="/2022/images/judgebg-01.png" alt="" /></div></section>
      <section id="Judges">
        <div className="Judges_info">
          <div className="Judges_Title">評審</div>
          <div className="Judges_TitleLine"><div className="Judges_TitleLineDot"><img src="/2022/images/linedot.png" alt="" /></div></div>
          <div className="Judges_HeadofJudge">
            <div className="Judges_HeadofJudge_Image"><img src="/2022/images/judgebubble-bg.png" alt="" /></div>
            <div className="Judges_HeadofJudge_info">
              <div className="Judges_HeadofJudge_Title">評審主席</div>
              <div className="Judges_HeadofJudge_Name">鄧淑明博士, MH, JP</div>
              <div className="Judges_HeadofJudge_Reputation">智慧城市聯盟<br />創辦人及榮譽會長</div>
              <div className="Judges_HeadofJudge_Details">鄧淑明博士，MH，太平紳士，香港大學計算機科學系榮譽教授，香港土生土長培育的資訊科技界企業家。鄧博士於九十年代創辦 Esri中國（香港）有限公司，專門推廣地理資訊系統(GIS)軟件和提供相關解決方案。</div>
            </div>
          </div>
          <div className="Judges_PanelofJudge">
            <div className="Judges_Title">評審委員</div>
            <div className="Judges_PanelofJudge_Table">
              {panelJudges.map(([img, name, rep]) => (
                <div className="Judges_PanelofJudge_Judge" key={name}>
                  <div className="Judges_PanelofJudge_Image">
                    <div className="Judges_PanelofJudge_Image_bg"><img src="/2022/images/judgebubble-bg.png" alt="" /></div>
                    <div className="Judges_PanelofJudge_Image_judge"><img src={`/2022/images/${img}.png`} alt="" className="clip-circle" /></div>
                  </div>
                  <div className="Judges_PanelofJudge_Info">
                    <div className="Judges_PanelofJudge_Name">{name}</div>
                    <div className="Judges_PanelofJudge_Reputation" dangerouslySetInnerHTML={{ __html: rep }} />
                  </div>
                </div>
              ))}
            </div>
            <div className="Judges_Title">法律顧問</div>
            <div className="Judges_PanelofJudge_Table">
              <div className="Judges_PanelofJudge_Judge">
                <div className="Judges_PanelofJudge_Image">
                  <div className="Judges_PanelofJudge_Image_bg"><img src="/2022/images/judgebubble-bg.png" alt="" /></div>
                  <div className="Judges_PanelofJudge_Image_judge"><img src="/2022/images/valenttse.png" alt="" className="clip-circle" /></div>
                </div>
                <div className="Judges_PanelofJudge_Info">
                  <div className="Judges_PanelofJudge_Name">謝遠明律師</div>
                  <div className="Judges_PanelofJudge_Reputation">董吳謝林律師事務所<br />合夥人</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer2022 lang="zh" />
    </div>
  );
};

export default Judges2022Zh;

